<main class="main vh-100">
  <section class="auth-login h-100">
    <div class="auth-login-grid">


      <!-- STAGE: dark showroom panel -->
      <div class="auth-stage d-none d-md-flex">
        <div class="auth-stage-glow"></div>

        <!-- NEW: sweeping spotlight -->
        <!-- <div class="auth-stage-spotlight"></div> -->

        <!-- NEW: floating particles -->
        <div class="auth-stage-particles" aria-hidden="true">
          <span></span><span></span><span></span><span></span><span></span><span></span>
        </div>

        <span class="auth-stage-rail">ADMIN ACCESS</span>

        <div class="auth-stage-live">
          <span class="auth-stage-liveDot"></span>
          System online
        </div>

        <div class="auth-stage-car">
          <img src="../../../assets/img/car.png" class="auth-stage-carImg" alt="Featured lot" />
        </div>

        <div class="auth-stage-copy">
          <span class="auth-stage-eyebrow">Marketplace Auction &amp; Exchange</span>
          <h1 class="auth-stage-heading auth-stage-heading--shimmer">
            Every auction runs<br />through here.
          </h1>
          <p class="auth-stage-sub">
            Sign in to manage auctions, users, bidders and purchase records.
          </p>
        </div>

        <div class="auth-stage-ticker">
          <span>№ 12 AUCTIONS LIVE</span>
          <span>№ 48 NEW BIDDERS TODAY</span>
          <span>№ 7 PURCHASES PENDING</span>
        </div>
      </div>

      <!-- TICKET: registration / login panel -->
      <div class="auth-ticket">
        <div class="auth-ticket-perf" aria-hidden="true"></div>

        <div class="auth-ticket-inner">
          <div class="auth-ticket auth-ticket--enter"></div>

          <div class="auth-ticket-header">
            <a href="" class="auction-logo">
              <img src="/assets/img/auction_system_logo.png" alt="Marketplace Auction & Exchange"
                class="auction-logo-img" />
            </a>
          </div>

          <form method="POST" class="auth-login-form credential mt-5" [formGroup]="loginForm" (submit)="login()">
            <h2 class="auth-ticket-title">Welcome back</h2>
            <p class="auth-ticket-subtitle">
              Enter your credentials to access the control panel.
            </p>

            <div class="form-group">
              <label class="credential__floatLabel" for="email">Email</label>
              <input id="email" type="email" class="form-control credential__input transparent" name="email"
                formControlName="email" placeholder="you@example.com"
                [class.is-invalid]="formData.email.invalid && submitted" />

              <div class="errors" *ngIf="formData.email.invalid && submitted">
                <ng-container *ngIf="formData.email.errors?.required">Email is required.</ng-container>
                <ng-container *ngIf="formData.email.errors?.email">Please enter a valid email.</ng-container>
              </div>
            </div>

            <div class="form-group">
              <label class="credential__floatLabel" for="password">Password</label>
              <input id="password" type="password" class="form-control credential__input transparent" name="password"
                formControlName="password" placeholder="••••••••"
                [class.is-invalid]="formData.password.invalid && submitted" />

              <div class="errors" *ngIf="formData.password.invalid && submitted">
                <ng-container *ngIf="formData.password.errors?.required">Password is required.</ng-container>
                <ng-container *ngIf="formData.password.errors?.minlength">
                  Required
                  {{
                  formData.password.errors?.minlength.requiredLength -
                  formData.password.errors?.minlength.actualLength
                  }}
                  more characters/digits.
                </ng-container>
              </div>
            </div>

            <div class="form-group auth-ticket-row mb-4">
              <div class="custom-control custom-checkbox">
                <input class="custom-control-input color-yellow" type="checkbox" name="remember" id="remember" />

                <label class="
                    form-check-label
                    custom-control-label
                    credential__label
                  " for="remember">
                  Remember me
                </label>
              </div>

              <a class="auth-ticket-forgot" routerLink="/forgot-password">
                Forgot password?
              </a>
            </div>

            <div class="auth-form-btnGrp mb-3">
              <button type="submit" [ladda]="loader.loading | async" data-style="slide-left"
                class="btn btn__main fs-normal w-100">
                Enter the floor
              </button>
            </div>

            <p class="auth-ticket-fine">
              Admin access is logged and monitored. By continuing, you agree to internal usage policies.
            </p>
          </form>

        </div>
      </div>

    </div>
  </section>
  <!-- <app-loader *ngIf="loader.loading | async"></app-loader> -->
</main>